@if (items$ | async; as items) {
<div class="ref-carousel-wrapper">
  @if (items.length > 0) {
  <div class="container">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
      @for (item of items; track item; let i = $index) {
      <div ngxSlickItem class="slide">
        @if (item | async; as data) {
        <div class="item">
          <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
            <div class="prod-image">
              <div>
                <cx-media
                  [container]="getImageRendition(data?.images?.PRIMARY)"
                  format="product"
                  [class.is-missing-fish]="businessType === 'fish'"
                  removeImageTitleAttr
                >
                </cx-media>
              </div>
            </div>
            <div class="prod-body">
              <div class="prod-code">{{ data.code }}</div>
              <div class="prod-name" [innerHTML]="data.name"></div>
              <div
                class="prod-price"
                [class.has-erp-promo]="atLeastOneHasErpPromo && !showSrp"
                [class.has-hybris-promo]="atLeastOneHasHybrisPromo && !showSrp"
              >
                <ng-container>
                  @if (!showSrp) {
                  <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                  <span
                    class="p-price"
                    [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== ''"
                  >
                    @if (!dealerPrice(data.code)) {
                    <div class="spinner-shimano-wrapper-dp">
                      @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (hasDealerPrice) {
                      <div class="spinner-shimano spinner-shimano-mr">
                        <div></div>
                      </div>
                      } @if (!hasDealerPrice && !tooltipIconConfig?.enabled) {
                      <div class="no-dealer-price no-dealer-price-alt test"></div>
                      } @else { @if (!hasDealerPrice && tooltipIconConfig?.enabled) {
                      <app-tooltip-icon
                        [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                        dealerPriceIconContainerClass="no-dealer-price-alt"
                        [uniqueClass]="data?.code"
                        placement="bottom-right"
                        [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                        [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                        [handleEvents]="tooltipIconConfig?.handleEvents"
                      ></app-tooltip-icon>
                      } } }
                    </div>
                    } @else {
                    {{ dealerPrice(data.code) }}@if (dealerPrice(data.code) && showGstExclusive$ | async) {
                    <span class="gst-label">{{ 'productCarousel.gstExclusive' | cxTranslate }}</span>
                    } }
                  </span>
                  } @if (showSrp) {
                  <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                  <span class="p-price"
                    >{{ data.srpPrice?.formattedValue }}@if (data.srpPrice?.formattedValue && showGstInclusive$ | async)
                    {
                    <span class="gst-label">{{ 'productCarousel.gstInclusive' | cxTranslate }}</span>
                    }</span
                  >
                  } @if (!showSrp && isDesktop$ | async) {
                  <div class="break"></div>
                  } @if (dealerPrices && !showSrp && isAlternative$ | async) {
                  <app-erp-promotional-text
                    class="promotional-text"
                    [dealerPriceData]="dealerPriceData(data?.code)"
                  ></app-erp-promotional-text>
                  } @if (atLeastOneHasHybrisPromo && !showSrp && isDesktop$ | async) {
                  <div class="break"></div>
                  } @if (dealerPrices && !showSrp && isAlternative$ | async) {
                  <app-promotional-text
                    [productCode]="data?.code"
                    [product]="data"
                    [promotionLocation]="'CAROUSEL'"
                    [charactersLimit]="45"
                  ></app-promotional-text>
                  }
                  <div class="break"></div>
                </ng-container>
              </div>
            </div>
          </a>
          <div class="prod-bottom container">
            <div class="row">
              <div class="col-sm-6">
                <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
                  <mat-icon class="material-icons-sharp light">assignment</mat-icon>
                </a>
              </div>
              <div class="col-sm-6">
                <a tabindex="0" type="button" class="order-form" (click)="addToCart(data.code)">
                  <mat-icon class="material-icons-sharp light">note_add</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </ngx-slick-carousel>
  </div>
  }
</div>
}
